import React, { useState, useEffect, useCallback, memo } from "react";

/**
 * ClockDisplay - Saat ve oturum süresi gösterimi
 *
 * Bu component MainLayout'tan ayrılarak oluşturuldu.
 * Sebep: Her saniye güncellenen saat, tüm MainLayout'un re-render olmasına neden oluyordu.
 * Bu component ile sadece saat kısmı re-render olur, ana layout sabit kalır.
 */
const ClockDisplay = ({ loginTime }) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    // Her saniye güncelle
    useEffect(() => {
        const interval = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);

    // Tarih formatla
    const formatDate = useCallback((date) =>
        date.toLocaleString("tr-TR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }), []);

    // Geçen süreyi hesapla
    const getElapsedTime = useCallback(() => {
        const diff = Math.floor((Date.now() - loginTime) / 1000);
        const minutes = Math.floor(diff / 60);
        const seconds = diff % 60;
        return `${minutes} dk ${seconds < 10 ? "0" : ""}${seconds} sn`;
    }, [loginTime]);

    return (
        <>
            <span>⏱ {getElapsedTime()}</span>
            <span>🕒 {formatDate(currentTime)}</span>
        </>
    );
};

// React.memo ile sarmalama - parent re-render olsa bile loginTime değişmedikçe re-render olmaz
export default memo(ClockDisplay);
